import { render, staticRenderFns } from "./ComboboxUnidadeRegional.vue?vue&type=template&id=4613ada2"
import script from "./ComboboxUnidadeRegional.vue?vue&type=script&lang=js"
export * from "./ComboboxUnidadeRegional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports